import type { Block } from '../types.js'

export type BlockGraphDirection = 'outgoing' | 'incoming' | 'both'

export function collectConnectedBlockIds(
  blocks: Block[],
  sourceId: string,
  direction: BlockGraphDirection
): string[] {
  const byId = new Map<string, Block>()
  const incomingById = new Map<string, string[]>()

  blocks.forEach(block => {
    const blockId = block.ided[0]
    byId.set(blockId, block)
    block.link.forEach(targetId => {
      const existing = incomingById.get(targetId)
      if (existing) {
        existing.push(blockId)
      } else {
        incomingById.set(targetId, [blockId])
      }
    })
  })

  const visited = new Set<string>()
  const queue: string[] = []
  const source = byId.get(sourceId)

  if (direction === 'outgoing' || direction === 'both') {
    source?.link.forEach(id => queue.push(id))
  }
  if (direction === 'incoming' || direction === 'both') {
    incomingById.get(sourceId)?.forEach(id => queue.push(id))
  }

  while (queue.length) {
    const next = queue.shift()
    if (!next || visited.has(next)) continue
    visited.add(next)

    if (direction === 'outgoing' || direction === 'both') {
      byId.get(next)?.link.forEach(id => {
        if (!visited.has(id) && id !== sourceId) queue.push(id)
      })
    }
    if (direction === 'incoming' || direction === 'both') {
      incomingById.get(next)?.forEach(id => {
        if (!visited.has(id) && id !== sourceId) queue.push(id)
      })
    }
  }

  visited.delete(sourceId)
  return Array.from(visited)
}
